const $ = jQuery.noConflict();

'use strict';

const Accordion = {
	/**
	 * @description Cache DOM and strings
	 */
	$accordionItem: $('.js-accordion-item'),
	$accordionHeader: $('.js-accordion-header'),
	classActive: 'is-active',

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	/**
	 * @description Bind Events
	 */
	bindEvents: function() {
		this.$accordionHeader.on('click', this.toggleAccordion.bind(this));
	},

	/**
	 * @description Toggle Accordion
	 */
	toggleAccordion: function(e) {
		const $currentItem = $(e.target).closest('.js-accordion-item');

		// Close all other accordion items
		this.$accordionItem.not($currentItem).removeClass(this.classActive);
		this.$accordionItem.not($currentItem).find('.js-accordion-content').slideUp();

		// Toggle the clicked item
		$currentItem.toggleClass(this.classActive);
		$currentItem.find('.js-accordion-content').slideToggle();
	}
};

export default Accordion;
